<div *ngIf="user" class="wrap-box">
  <div class="cover-picture-box">
    <div class="cover-picture">
      <img class="CP" src="https://studenty.onrender.com/User/{{ user.coverImage }}" alt="Photo de Couverture" />
    </div>
  </div>
  <img src="https://studenty.onrender.com/User/{{ user.profileImage }}" alt="Photo de profile" class="profile-picture" alt="Profile-picture"/>
  <h3>{{ user.titre }}</h3>

  <ul class="nav-list">
    <li class="nav-item" (click)="activeSection = 'alumni'" [ngClass]="{'active-section': activeSection === 'alumni'}">Alumni</li>
    <li class="nav-item" (click)="activeSection = 'clubevents'" [ngClass]="{'active-section': activeSection === 'clubevents'}">Events</li>
    <li class="nav-item" (click)="activeSection = 'rating'" [ngClass]="{'active-section': activeSection === 'rating'}">Rating</li>
  </ul>
  
<!--
  <section style="background-color: #d94125;">
    <div class="container my-5 py-5 text-dark">
      <div class="row d-flex justify-content-center">
        <div class="col-md-10 col-lg-8 col-xl-6">
          <div class="card">
            <div class="card-body p-4">
              <div class="d-flex flex-start w-100">
                <img class="rounded-circle shadow-1-strong me-3"
                  src="https://mdbcdn.b-cdn.net/img/Photos/Avatars/img%20(21).webp" alt="avatar" width="65"
                  height="65" />
                <div class="w-100">
                  <h5>Add a comment</h5>
                  <ul class="rating mb-3" data-mdb-toggle="rating">
                    <li>
                      <i class="far fa-star fa-sm text-danger" title="Bad"></i>
                    </li>
                    <li>
                      <i class="far fa-star fa-sm text-danger" title="Poor"></i>
                    </li>
                    <li>
                      <i class="far fa-star fa-sm text-danger" title="OK"></i>
                    </li>
                    <li>
                      <i class="far fa-star fa-sm text-danger" title="Good"></i>
                    </li>
                    <li>
                      <i class="far fa-star fa-sm text-danger" title="Excellent"></i>
                    </li>
                  </ul>
                  <div class="form-outline">
                    <textarea class="form-control" id="textAreaExample" rows="4"></textarea>
                    <label class="form-label" for="textAreaExample">What is your view?</label>
                  </div>
                  <div class="d-flex justify-content-between mt-3">
                    <button type="button" class="btn btn-success">Danger</button>
                    <button type="button" class="btn btn-danger">
                      Send <i class="fas fa-long-arrow-alt-right ms-1"></i>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>

   Comments-->
   <!--Adding Comment-->
   <div *ngIf="activeSection === 'rating'">
  <div class="form-group" *ngIf="comment" >
    <input style="width: 90%; height: 40px; margin-left: 0px;" type="text" class="form-control" placeholder="Comment" [(ngModel)]="comment.description" required #description="ngModel"/>
    <a href="/home/clubsdata/details">
      <button class="btn btn-primary" style="height: 40px; margin-left: -20%;" (click)="addComment(comment)" [disabled]="description.invalid"> Add Comment </button>

    </a>
  </div>
  <!--Rating Comments-->
<div class="main-card"  *ngFor="let com of commentaire">
<div class="cards">
  <div class="card">
    <div class="content">
      <li style="list-style-type: none; float: left; margin-left: -85%; margin-top: -20px;">
        <img class="comPic" src="https://studenty.onrender.com/User/{{ com.user.profileImage }}" style="width: 60px; height: 60px; border-radius: 50%; border: 2px solid #5a54ff; display: inline;" alt="profile Image"/>
        <a class="nav-link" style="font-weight: bold; display: inline; color: black; margin-left: 0px; margin-bottom: 10px;">
          <i class="ion-md-power"></i> &nbsp; {{com.user.nom}} {{com.user.prenom}} <br><small class="pub" style="margin-left: 125px;display: block;transform: translateY(-26px);">Published on : {{com.date}}</small>
        </a>
        <br>
      </li>
        <p style="margin-left: 8%; margin-right:8% ; margin-top: 10px; color: black; text-align: justify;" >{{com.description}}</p>
        <br>
        <!--<p style="margin-left: -100px; color: #5a54ff;" (click)="getReponseByCommentaireId(com._id)">Show Respons</p>-->
    </div>
    <a href="/home/clubsdata/details" (click)="deleteCommentaire(com._id)" [hidden]="hideSupp(com.user._id)"><fa-icon [icon]="faTrash"  class="material-icons" style="display: flex;float: right; transform: translateY(-900%);margin-right: 30px;"></fa-icon></a>

  </div>
</div>
</div>
  
</div>
<!-- <div class="clubevents"> -->
<div  *ngIf="activeSection === 'clubevents'">
<div class="blog-slider5">

  <br />
  <br />
  <div class="container">
    <div class="row">
      <div *ngFor="let events of ListEvent; let i; of: index">
        <div class="main-card" style="width: 100%">
          <div class="cards">
            <div class="card" style="width: 336px; height: 335px">
              <div class="content">
                <li style="list-style-type: none">
                  <!-- <img src="https://studenty.onrender.com/User/{{ posts.user.profileImage }}" style="width: 50px; height: 50px; border-radius: 50%; border: 2px solid #5A54FF; display: inline;" alt=""/>
                    <a class="nav-link" style="font-weight: bold; display: inline; color: black; ">
                      <i class="ion-md-power"></i> {{posts.user.nom}} {{posts.user.prenom}}
                    </a>-->
              
                    
                  <br />

                  <!--<small>Published on : {{posts.date}}</small>-->
                </li>
                <div class="img" style="border: 2px red !important">
                  <img
                    src="https://studenty.onrender.com/Event/{{ events.image }}"
                    style="width: 270px; height: 150px"
                    alt="Post Picture"
                  />
                </div>
                <div class="details">
                  <div class="name" style="hyphens: none; color: #1b2559; margin-bottom: -5px; font-size: 24px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap;">
                    {{ events.titre }}
                  </div>
                </div>
                
                

                <p style="width: 80%; height: 30px; color: #a3aed0; margin-bottom: 0px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap;">
                  {{ events.description | slice:0:100 }}{{ events.description.length > 100 ? '...' : '' }}
                </p>
                
                

                

                <!--
                  <a style=" font-size: large; margin-left: -80%;margin-top: -18%;" (click)="likePost(posts._id)"  href="/home/posts">
                    <i class="fa-sharp fa-solid fa-heart fa-beat-fade" style="color: #000000;"></i>
                  </a>
                 <a style=" font-size: large; margin-left: -65%; margin-top: -6.3%; " (click)="dislikePost(posts._id)"  href="/home/posts">
                    <fa-icon style="color: #5A54FF;" [icon]="faThumbsDown"  class="material-icons"></fa-icon>
                  </a>-->

                
                
                <div style="margin-left: 65px; ">
                  <button
                    class="custom-button"
                    (click)="setEventId(events._id)"
                    [routerLink]="'/home/events/event'"
                  >
                    See More
                  </button>
                </div>

                <br />

              </div>
              
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

</div>

<!--Alumni club -->
<div *ngIf="activeSection === 'alumni'">
<table class="custom-table">
  <thead>
    <tr>
      <th>Full name</th>
      <th>Gender</th>
      <th>Mission</th>
      <th>Session <i class="fas fa-edit edit-icon" ></i></th>
    </tr>
  </thead>
  <tbody>
    <tr *ngFor="let alumni of ListAlumni">
      <td>
        <div class="name-column">
          <img class="profile-photo" src="https://studenty.onrender.com/User/{{ alumni.coverImage }}" alt="Med Ali Jlassi">
        {{alumni.nom}} {{alumni.prenom}}
        </div>
      </td>
      <td>Male</td>
      <td>{{alumni.departement}}</td>
      <td>{{alumni.session}} 

      </td>

    </tr>
 
  
  </tbody>
</table>
</div>
</div>